module.exports = __webpack_public_path__ + "static/media/icon_nikkei.18b07139.svg";